import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'
import { useCustomerStore } from '@stores/me/customer'

import { useKidInCustomer } from '@hooks/kid/kid-in-customer.hook'

interface DisciplineInKidReturn {
  isDisciplineMath: ComputedRef<boolean>
  isDisciplineEla: ComputedRef<boolean>
  isMathLanding: ComputedRef<boolean>
  isElaLanding: ComputedRef<boolean>
}
export const useDisciplineInKid = (): DisciplineInKidReturn => {
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()
  const customerStore = useCustomerStore()

  const {
    kid,
  } = useKidInCustomer({
    kidId: kidStore.activeKidId!,
  })

  const disciplines = computed<Discipline[]>(() => {
    return (kid.value?.disciplines || []).map(disciplineInKid => disciplineInKid.code)
  })

  const isDisciplineMath = computed(() => disciplines.value.includes(Discipline.Math))
  const isDisciplineEla = computed(() => disciplines.value.includes(Discipline.ELA))

  const hasNoDisciplineAccess = computed(() =>
    !customerStore.isActiveDisciplineDemoInKid && !customerStore.isActiveDisciplinePaid,
  )

  const isMathLanding = computed(() =>
    !isDisciplineMath.value || disciplineStore.isMathLanding || hasNoDisciplineAccess.value,
  )

  const isElaLanding = computed(() =>
    !isDisciplineEla.value || disciplineStore.isElaLanding || hasNoDisciplineAccess.value,
  )

  return {
    isDisciplineMath,
    isDisciplineEla,
    isMathLanding,
    isElaLanding,
  }
}
